module.exports = __webpack_public_path__ + "img/CF.97629cb9.svg";